import { HoverCard, UnstyledButton } from "@mantine/core";
import { CircleAlert } from "lucide-react";

import classes from "./UsageNotes.module.css";

/**
 * Live's "Usage notes" (its `UsageNotesButton`): a yellow pin beside the price whose card lists a
 * model's notes on hover; nothing when the model has none.
 */
export function UsageNotes({ notes }: { notes: readonly string[] }) {
  if (notes.length === 0) return null;
  return (
    <HoverCard width={320} position="top" shadow="md" withArrow arrowSize={8}>
      <HoverCard.Target>
        <UnstyledButton aria-label="Usage notes" className={classes.button}>
          <CircleAlert size={16} strokeWidth={1.5} className={classes.icon} aria-hidden />
        </UnstyledButton>
      </HoverCard.Target>
      <HoverCard.Dropdown className={classes.dropdown}>
        <ul className={classes.list}>
          {notes.map((note) => (
            <li key={note} className={classes.note}>
              {note}
            </li>
          ))}
        </ul>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
